import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';
import { COOKIE_POLICY_PATH } from '@/components/layout/AppCookieConsent/types';

const CookieConsentPolicyPage = lazy(() =>
  import('@/components/layout/AppCookieConsent/CookieConsentPolicyPage').then(({ CookieConsentPolicyPage }) => ({
    default: CookieConsentPolicyPage,
  })),
);

export const CookieConsentPolicyRoute: AppRouteConfig = {
  key: 'cookie-consent-policy-page',
  path: `${COOKIE_POLICY_PATH}/:locale?`,
  component: CookieConsentPolicyPage,
};
